import { render, staticRenderFns } from "./cateNav.vue?vue&type=template&id=2277e36e&scoped=true"
import script from "./cateNav.vue?vue&type=script&lang=js"
export * from "./cateNav.vue?vue&type=script&lang=js"
import style0 from "./cateNav.vue?vue&type=style&index=0&id=2277e36e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2277e36e",
  null
  
)

export default component.exports